import React, { useState } from 'react';
import { useAccount, useNewsletter } from '@Provider/frontastic';
import { SubscriptionResponse } from '@Types/newsletter/SubscriptionResponse';
import { set } from 'immutable';
import Button from 'components/revelo-ui/content/button';
import EnvelopeIcon from '../../../../icons/envelope';
import classnames from 'classnames';

export type NewsletterProps = {
  listId: string;
  newsletterText: string;
  newsletterDisclaimerText: string;
  newsletterSuccessMessage?: string;
  permissionId: string;
};

const Newsletter: React.FC<NewsletterProps> = ({
  listId,
  newsletterText,
  newsletterDisclaimerText,
  newsletterSuccessMessage,
  permissionId,
}) => {
  const { update } = useNewsletter();
  const { account } = useAccount();
  const [success, setSuccess] = useState<boolean>(false);

  const newsletterCall = async () => {
    const res = await update({
      listId,
      customMergeFields: null,
      userData: {
        email: account.email,
      },
      permissions: [
        {
          marketing_permission_id: permissionId,
          enabled: true,
        },
      ],
    });

    setSuccess(res.success);
  };

  return (
    <div className="flex flex-col gap-6">
      <h3 className="font-headline text-lg">Anmeldung zum Newsletter</h3>
      {success ? (
        <p>{newsletterSuccessMessage}</p>
      ) : (
        <div className="flex flex-col items-start gap-6">
          <p>{newsletterText}</p>
          <p className="text-[11px]">{newsletterDisclaimerText}</p>
          <Button style="primary" onClick={newsletterCall}>
            <span className="flex items-center justify-center gap-2">
              <EnvelopeIcon className={classnames('size-6', {})} aria-hidden="true" />
              <div>Jetzt anmelden!</div>
            </span>
          </Button>
        </div>
      )}
    </div>
  );
};

export default Newsletter;
